class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;
    this.megaMenuContent = this.querySelector('.mega-menu__content');

    this.addEventListener('mouseenter', this.open.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    
    if (this.megaMenuContent) {
      this.megaMenuContent.addEventListener('mouseenter', this.open.bind(this));
      this.megaMenuContent.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  }

  static openMenus() {
    return [...document.querySelectorAll('header-menu')].filter((menu) => menu.mainDetailsToggle.hasAttribute('open'));
  }

  static fadeDuration() {
    const time = window.getComputedStyle(document.documentElement).getPropertyValue('--duration-header-fade').trim();
    return time.endsWith('ms') ? parseFloat(time) : parseFloat(time) * 1000;
  }

  static updateOverlay() {
    const anyMenuShowing = HeaderMenu.openMenus().some((menu) => !menu.fadeOut);
    document.body.classList.toggle('overlay-active', anyMenuShowing);
  }

  onMouseLeave() {
    this.closeTimeout = setTimeout(() => this.close(), 500);
  }

  open() {
    clearTimeout(this.closeTimeout);
    this.cancelFadeOut();
    const otherMenus = HeaderMenu.openMenus().filter((menu) => menu !== this);
    const shouldFade = !this.mainDetailsToggle.hasAttribute('open') && otherMenus.length === 0;
    this.mainDetailsToggle.setAttribute('open', '');
    if (shouldFade) this.fade([0, 1]);
    otherMenus.forEach((menu) => menu.finishClose());
    HeaderMenu.updateOverlay();
  }

  fade(opacity) {
    return this.content.animate({ opacity }, { duration: HeaderMenu.fadeDuration(), easing: 'ease' });
  }

  close() {
    clearTimeout(this.closeTimeout);
    if (!this.mainDetailsToggle.hasAttribute('open') || this.fadeOut) return;
    if (!HeaderMenu.fadeDuration()) return this.finishClose();

    this.fadeOut = this.fade([1, 0]);
    this.fadeOut.onfinish = () => this.finishClose();
    HeaderMenu.updateOverlay();
  }

  cancelFadeOut() {
    this.fadeOut?.cancel();
    this.fadeOut = null;
  }

  finishClose() {
    this.cancelFadeOut();
    super.close();
    HeaderMenu.updateOverlay();
  }

  onToggle() {
    if (!this.mainDetailsToggle.hasAttribute('open')) this.cancelFadeOut();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    HeaderMenu.updateOverlay();

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

document.querySelector('.header__menu')?.addEventListener('mouseover', (event) => {
  const navItem = event.target.closest('.header__menu-list-item');
  if (!navItem || navItem.classList.contains('has-dropdown')) return;
  HeaderMenu.openMenus().forEach((menu) => menu.close());
});
